import "./dynamic-table.css";
import { formatAsEuro } from "../../helpers/helpers";
import CloseIcon from "../svgs/closeIcon";
import { useAppContext } from "../../AppContext";
import { CartItem } from "../../file.interface";
import { getKey } from "../increaser-decreaser/counter";

interface GeneralDynamicTableProps {
  items: CartItem[];
}
const GeneralDynamicTable: React.FC<GeneralDynamicTableProps> = ({ items }) => {
  const { selectedContractDuration } = useAppContext();
  const { dispatch } = useAppContext();

  const removeItem = (item: CartItem) => {
    const itemIndex = items.findIndex((_item) => _item.id === item.id);
    if (itemIndex !== -1) {
      let alreadyRemoved = false;
      let newFlow = items.filter((_item) => {
        if (_item.id === item.id && !alreadyRemoved) {
          alreadyRemoved = true;
          return false;
        }
        return true;
      });

      let key = getKey(item);

      dispatch({
        type: "UPDATE_CONTEXT",
        payload: {
          [key]: newFlow,
        },
      });
    }
  };

  return (
    <div className="product-table-main-container">
      {items.map((item, i) => {
        let itemPrice: string | number = item.prices[selectedContractDuration];
        let itemTitle: string = item.name;
        itemPrice = formatAsEuro(itemPrice);

        return (
          <div key={i}>
            <div style={{ margin: "0px 10px -20px 10px", textAlign: "right" }}>
              <CloseIcon
                width={10}
                height={10}
                onClick={() => removeItem(item)}
              />
            </div>
            <div className="product-row-container">
              <div className="item-table">
                <div className="product-row-img">
                  <img src={item.imageUrl} alt="" />
                </div>
                <div className="product-row-name">{itemTitle}</div>
              </div>
              <div className="product-row-price">{itemPrice}</div>
            </div>
            {i === items.length - 1 && items.length > 1 && (
              <>
                <div className="app-separator" />
                <div className="total-align-right">
                  Total:{" "}
                  {formatAsEuro(
                    items.reduce(
                      (total, item) =>
                        total + item.prices[selectedContractDuration],
                      0
                    )
                  )}
                </div>
              </>
            )}
            {i !== items.length - 1 && <div className="app-separator" />}
          </div>
        );
      })}
    </div>
  );
};

export default GeneralDynamicTable;
